export default __webpack_public_path__ + "static/media/start.33096ba6.svg";